(function () {
  'use strict';

  angular
    .module('flyingHourSummaryReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('flyingHourSummaryReport', {
        url: '/flying-hour-summary-report',
        views:{
        	'flyingHourSummaryReportView' :{
        		templateUrl: 'flying-hour-summary-report/views/flying-hour-summary-report.tpl.html',
        		controller: 'FlyingHourSummaryReportCtrl',
        		controllerAs: 'flyingHourSummaryReport'
        	}
        }
      });
  }
}());
